import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import type { MaImage } from '@/lib/zybooks-api';
import { getMaImageUrl } from './image-library-utils';

interface ImagePreviewModalProps {
    onClose: () => void;
    image: MaImage | null;
    onEditAltText?: (image: MaImage) => void;
}

export const ImagePreviewModal: React.FC<ImagePreviewModalProps> = props => {
    const { onClose, image: imagePreview, onEditAltText } = props;

    return (
        <Dialog
            open={imagePreview !== null}
            onOpenChange={onClose}
        >
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{imagePreview?.filename}</DialogTitle>
                </DialogHeader>
                <img
                    src={imagePreview ? getMaImageUrl(imagePreview as MaImage) : undefined}
                    alt={imagePreview?.alt_text ?? 'Preview'}
                    className="w-full h-auto"
                />
                {imagePreview?.alt_text ? (
                    <p className="text-sm text-muted-foreground">{imagePreview.alt_text}</p>
                ) : (
                    <p className="text-sm text-muted-foreground italic">No alt text</p>
                )}
                {onEditAltText && imagePreview ? (
                    <DialogFooter>
                        <Button
                            variant="outline"
                            onClick={() => onEditAltText(imagePreview)}
                        >
                            Edit alt text
                        </Button>
                    </DialogFooter>
                ) : null}
            </DialogContent>
        </Dialog>
    );
};
